// extracted by mini-css-extract-plugin
module.exports = {"pg-user__filter":"styles_pg-user__filter__1GEqo","pg-user__filter__actions":"styles_pg-user__filter__actions__2Ewof","pg-user__table":"styles_pg-user__table__1ocaA"};